import { render } from "./Label.vue?vue&type=template&id=284d964a"
import script from "./Label.vue?vue&type=script&lang=js"
export * from "./Label.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./Label.vue?vue&type=style&index=0&id=284d964a&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script